export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20stylized%20anime%20manga%20atmosphere%20background%20with%20soft%20cherry%20blossom%20petals%20floating%20in%20golden%20hour%20light%2C%20artistic%20illustration%20style%20with%20warm%20amber%20and%20coral%20tones%2C%20dreamy%20bokeh%20effect%2C%20Japanese%20manga%20aesthetic%2C%20subtle%20paper%20texture%2C%20elegant%20and%20modern%20composition%2C%20no%20text%2C%20abstract%20artistic%20rendering&width=1600&height=900&seq=hero-bg-sakura&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs font-medium mb-5 border border-white/10">
              每日更新 · 日漫资源聚合平台
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
              樱花动漫之家<span className="text-accent-300">·</span><br className="sm:hidden" /> 日漫爱好者的精神角落
            </h1>

            <p className="text-white/80 text-lg font-heading mb-6">
              从经典神作到最新连载，一站式漫游日本漫画世界
            </p>

            <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              樱花动漫之家专注日本漫画资源聚合与推荐，每日追踪热门日漫连载动态。
              无论你热衷少年热血、少女柔情还是悬疑推理，这里都有为你精心甄选的日漫佳作。
              每周更新编辑精选专题，让追漫不再盲目，发现属于你的下一部心头好。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">12,000+</div>
                <div className="text-xs text-white/55 mt-1">累计收录漫画</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">200+</div>
                <div className="text-xs text-white/55 mt-1">每日更新章节</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">50万+</div>
                <div className="text-xs text-white/55 mt-1">月活跃漫友</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                开始探索
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 backdrop-blur-sm text-white border border-white/20 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-white/20 transition-colors"
              >
                本周推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20Japanese%20manga%20illustration%20featuring%20a%20dynamic%20composition%20of%20manga%20panels%20and%20characters%20in%20warm%20coral%20and%20amber%20tones%2C%20artistic%20rendering%20with%20soft%20brush%20strokes%2C%20cherry%20blossom%20motif%2C%20modern%20editorial%20design%20aesthetic%2C%20clean%20composition%2C%20elegant%20Japanese%20illustration%20style%2C%20warm%20lighting%2C%20no%20text%20overlay&width=800&height=1000&seq=hero-visual-main&orientation=portrait"
                alt="樱花动漫之家日漫主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}